import { UseFormReset } from 'react-hook-form';

import { FormProvider, useNotificationContext } from 'core/states';
import { useComponentTemplateActions } from 'elements/hooks';
import { IComponentTemplate, IElementTemplate } from 'elements/types';

import { AddLineFormFields } from './AddLineFormFields';
import { addPartLineSchema } from './schema';
import { IAddPartLineFormData } from './types';

interface IProps {
  elementTemplate: IElementTemplate;
  isOpen: boolean;
  onClose: () => void;
  onSubmitSuccess?: (part: IComponentTemplate) => void;
}

export const AddLine = ({ elementTemplate, isOpen, onClose, onSubmitSuccess }: IProps) => {
  const { clearNotification } = useNotificationContext();

  const { upsertComponentTemplate } = useComponentTemplateActions();

  const onSubmit =
    (reset: UseFormReset<IAddPartLineFormData>) => async (data: IAddPartLineFormData) => {
      let descriptionData = {};
      if (!data.part?.verified) {
        descriptionData = {
          description: data.description,
          descriptionLong: data.description,
          name: data.description,
        };
      }

      const payload = {
        componentTemplate: {
          elementTemplateId: elementTemplate.id,
          part: data.part?.number,
          manufacturerId: data.manufacturer?.id,
          quantity: data.quantity,
          uom: data.uom,
          ...descriptionData,
        },
        viewBy: {
          elementTemplateId: elementTemplate.id,
        },
      };

      const { success, componentTemplate: savedComponentTemplate } =
        await upsertComponentTemplate(payload);

      if (!success) {
        return;
      }

      setTimeout(() => {
        handleOnClose(reset);

        onSubmitSuccess?.(savedComponentTemplate);
      }, 1000);
    };

  const handleOnClose = (reset?: UseFormReset<IAddPartLineFormData>) => {
    clearNotification();
    onClose();
    reset?.({});
  };

  return (
    <FormProvider schema={addPartLineSchema()} defaultValues={{}} resetDefaultValues>
      <AddLineFormFields isOpen={isOpen} onClose={handleOnClose} onSubmit={onSubmit} />
    </FormProvider>
  );
};
